import * as React from 'react';
import styled from 'styled-components';
import MuiDialogActions, { DialogActionsProps as MuiDialogActionsProps } from '@material-ui/core/DialogActions';

const StyledDialogActions = styled(MuiDialogActions)<{ $minWidth?: string | false }>`
    ${props => props.$minWidth && `min-width: ${props.$minWidth};`}
`;

export type DSDialogActionsProps = MuiDialogActionsProps & { minWidth?: string | false };
export const DSDialogActions: React.FC<DSDialogActionsProps> = ({ minWidth = '500px', ...props }) => (
    <StyledDialogActions {...props} $minWidth={minWidth} />
);
DSDialogActions.displayName = 'DSDialogActions';
